/*#__PURE__*/ export default {"key":"balances","type":"root","items":[{"key":"pollingInterval","def":60,"type":"int"}]};